const FUTURE = 1;
const PREGAME = 2;
const LIVE = 3;
const CRITICAL = 4;
const SOFT_FINAL = 5;
const HARD_FINAL = 6;
const OFFICIAL = 7;

export default {
    FUTURE,
    PREGAME,
    LIVE,
    CRITICAL,
    SOFT_FINAL,
    HARD_FINAL,
    OFFICIAL
};
